// extracted by mini-css-extract-plugin
module.exports = {"sm":"576px","md":"768px","lg":"992px","xl":"1200px","xxl":"1440px","spacing":"4px","middleCenter":"LoadingPage_middleCenter__1HB9m","spinner":"LoadingPage_spinner__1lw17"};